
// FORM SEARCH
 const btnSearch = document.querySelector('.Header .jsBtnSearch');
 const form = document.querySelector('.Header .SearchDrawer__Form-header');
 btnSearch && btnSearch.addEventListener('click', addEventSubmmitForm)

// const btnViewAlls = document.querySelectorAll('.js-view-all');
// btnViewAlls.forEach(btnViewAll => {
//   btnViewAll && btnViewAll.addEventListener('click', addEventSubmmitForm);
// })

function addEventSubmmitForm(event) {
 event.preventDefault();
  const username = form.querySelector('input[type="search"]').value;
 if (username.trim().length > 0) {
  form.submit();
 }
}


(()=>{
  const header = document.querySelector(".Header");
  const headerEl = document.querySelector(".Header .Header__Main-wrapper");
  let heightHeader = header.clientHeight;
  
  // window.addEventListener("resize", function() {
  //   heightHeader = header.clientHeight;
  // })
  

  // let {height: lastFrame} = getFrame(window.scrollY < header.clientHeight);

  window.addEventListener("scroll", function() {
    // if(!window.matchMedia('(min-width: 1008px)').matches) return;

    if (window.scrollY > header.clientHeight) {
      header.classList.add('header_sticky');
      header.style.height = heightHeader + 'px';
    }
    else {
      header.classList.remove('header_sticky');
    }

   
    
    // run(!header.classList.contains('header_sticky'))
  });

  

  // window.addEventListener("resize", function() {
  //   if(window.matchMedia('(min-width: 1008px)').matches) return;
    
  //   run(true);
  // })

  // function getFrame(showing){
  //   const headerHeight = header.scrollHeight;
    
  //   if(showing){
  //     return {
  //       height: [0, `${headerHeight}px`],
  //       opacity: [0, 1]
  //     }
  //   }
  //   else{
  //     return {
  //       height: [`${headerHeight}px`, 0],
  //       opacity: [1, 0]
  //     }
  //   }
  // }

  // function run(showing){

  //   let {height, opacity} = getFrame(showing);


  //   if(lastFrame.join() == height.join()) return;

  //   lastFrame = height;

  //   headerEl.animate({
  //     height,
  //     opacity,
  //     overflow: 'hidden',
  //     minHeight : 0
  //   },
  //   {
  //     duration: 300,
  //     easing: 'ease-out',
  //     fill:'both'
  //   });
  // }

  function debounceTime(fn, wait){
	let t;
	return (...args) => {
		clearTimeout(t);
		t = setTimeout(() => fn.apply(this, args), wait);
	};
}

function serializeForm(form){
	const obj = {};
	const formData = new FormData(form);
	let properties = {};
	let hasProperties = false;

	for (const key of formData.keys()) {

		if(key.includes('properties')){

			if(formData.get(key).length){
				let newKey = key.slice(0, key.length-1);
				newKey = newKey.replace('properties[', '');

				properties = Object.assign(properties, {
					[newKey]: formData.get(key)
				})
				hasProperties = true;
			}
		}
		else{
			obj[key] = formData.get(key);
		}
	}

	if(hasProperties)
		obj.properties = properties;

	console.log(obj);
	return JSON.stringify(obj);
}

  var PredictiveSearch = class extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector("form");
      this.input = this.querySelector("[name=q]");
      this.serializeForm = serializeForm;
      this.addEventListener("input", debounceTime((event) => {
        this.onChange(event);
      }, 300).bind(this));
      this.input.addEventListener("click", ()=> {
        this.onClick(event);
        this.onFocus.bind(this);
      });
      this.input.addEventListener("touchstart", this.onFocus.bind(this), { passive: true });
      this.addEventListener("focusout", this.onFocusOut.bind(this));
      this.addEventListener("keyup", this.onKeyup.bind(this));
      this.input.addEventListener("focus", () => {
        const parentElement = this.closest(".popup__body");
        parentElement && parentElement.classList.add("focus-input");
      });
      this.input.addEventListener("focusout", () => {
        const parentElement = this.closest(".popup__body");
        parentElement && parentElement.classList.remove("focus-input");
      });
    }
    onClick(e) {
    let key = e.target.value.trim();
      if(key == ''){
        this.getRequest();
      }else {
        this.getRequest(key);
        
}
    }
    onChange(e) {
      const key = e.target.value.trim();
      if (!key.length) {
        this.close();
        return;
      }
      this.getRequest(key);
    }
    getRequest(key, recommend) {
      this.searchQuery = JSON.parse(this.serializeForm(this.form));
      this.searchQuery.q = key;
      this.searchQuery.section_id = this.dataset.section;
      this.classList.add("is-searching");
      const query = new URLSearchParams(this.searchQuery).toString();
      const url = this.dataset.url + "?" + query;
      fetch(url).then((e) => e.text()).then((html) => {
        this.querySelector(".SearchDrawer__Results").innerHTML = html.split("<!-- /// -->")[1];
      }).finally(() => {
        this.classList.remove("is-searching");
        this.open();
      });
    }
    focusSearch() {
      console.log("focusSearch");
      this.input.focus();
    }
    open() {
      this.classList.add("show");
      // this.onViewAll();
      
    }
    close() {
      this.classList.remove("show");
    }
    onFocus() {
      this.open();
    }
    onFocusOut() {
      setTimeout(() => {
        if (!this.contains(document.activeElement))
          this.close();
      });
    }
    onKeyup(event) {
      if (event.code == "Escape")
        this.close();
    }
    onViewAll() {
      const btnViewAlls = document.querySelectorAll('.js-view-all');
    console.log(btnViewAlls);

      btnViewAlls.forEach(btnViewAll => {
        btnViewAll && btnViewAll.addEventListener('click', addEventSubmmitForm);
      })
    }
  };
  customElements.define("predictive-search", PredictiveSearch);

})();


/*
const headerMain = document.querySelector(".Header .Header__Main");
const headerMainHeight = headerMain.clientHeight + 20;
function HandleScroll(scrollDown) {

    if (scrollDown) {
        headerMain.style.transition = 'height 0.4s ease-out';
        headerMain.style.height = '0';
        headerMain.style.overflow = 'hidden';
        headerMain.style.minHeight = '0';
    } else {
        headerMain.style.transition = 'height 0.4s ease-in';
        headerMain.style.height = `${headerMainHeight}px`;
        headerMain.style.overflow = 'visible';
        headerMain.style.minHeight = `${headerMainHeight}px`;
    }
  }*/